import { render, staticRenderFns } from "./resource-tree.vue?vue&type=template&id=73880860&scoped=true"
import script from "./resource-tree.vue?vue&type=script&lang=ts"
export * from "./resource-tree.vue?vue&type=script&lang=ts"
import style0 from "./resource-tree.vue?vue&type=style&index=0&id=73880860&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73880860",
  null
  
)

export default component.exports